import React from 'react';
import {LocationPin} from "./LocationPin";
import {LocationToolTip} from "./LocationToolTip";
import {Location} from "../../types/location";
import {Mode} from "../../enum/mode";

type LocationMarkerProps = {
    location: Location,
    lat: number,
    lng: number,
    hover: boolean,
    selected: boolean,
    setSelectedLocation: (location : Location|null) => void
    setMapHoverLocation: (location : Location|null) => void,
    mode: Mode
}

export function LocationMarker({location, hover, selected, setSelectedLocation, setMapHoverLocation, mode} : LocationMarkerProps) {

    return (
        <span
            onClick={(e) => {
                e.stopPropagation();
                setSelectedLocation(location);
            }}
            onMouseEnter={() => setMapHoverLocation(location)}
            onMouseLeave={() => setMapHoverLocation(null)}
        >
            <LocationPin selected={selected} hover={hover} />
            {(selected || hover) && <LocationToolTip location={location} mode={mode}/>}
        </span>
    );
}
